import { combineReducers } from 'redux';

import CompaniesReducer from './CompaniesReducer';
import ResultsReducer from './ResultsReducer';
import AccountGroupsReducer from './AccountGroupsReducer';
import UsersReducer from './UsersReducer';
import ChatsStatsReducer from './ChatsStatsReducer';
import OpportunitiesReducer from './OpportunitiesReducer';
import TeamsReducer from './TeamsReducer';

export default combineReducers({
  companies: CompaniesReducer,
  results: ResultsReducer,
  accountGroups: AccountGroupsReducer,
  users: UsersReducer,
  chatsStats: ChatsStatsReducer,
  opportunities: OpportunitiesReducer,
  teams: TeamsReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/entities/index.js